exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "._8HGlD7hQ_CLMeFGZ45M87 {\n  width: 25vw;\n  height: 25vw;\n}", "",{"version":3,"sources":["Logo.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd","file":"Logo.css","sourcesContent":[".logo {\n  width: 25vw;\n  height: 25vw;\n}"]}]);
// Exports
exports.locals = {
	"logo": "_8HGlD7hQ_CLMeFGZ45M87"
};